module.exports = __webpack_public_path__ + "static/media/lending-tools1.115fd1c8.svg";